import { HOW_DOES_IT_WORK } from 'mk/autogenerated/translations/NewFeatureCheckout.296e4a60a06b097819df7e3a2daae9e8'
import { ACTIVE_SERVER_ID } from 'mk/settings';
import Badge, { BadgeType } from 'mk2/components/Badge';
import { Link } from 'mk2/components/Link';
import React from 'react';
import styles from './NewFeatureCheckout.mscss';

const BAZAAR_ORDER_HOW_DOES_IT_WORK_ARTICLE_URL = {
    201: '/blog/modrykonik/article/chces-s-nami-testovat-novu-funkciu-v-baz-bgibrt/',
    202: '/blog/modrykonik/article/chces-s-nami-testovat-novou-funkci-v-baz-dpxy65/',
}[ACTIVE_SERVER_ID];

const NewFeatureCheckout = () => {
    return (
        <div className={styles.NewFeatureCheckout}>
            <Badge type={BadgeType.New} />
            <Link
                className={styles.NewFeatureCheckout__explainLink}
                to={BAZAAR_ORDER_HOW_DOES_IT_WORK_ARTICLE_URL}
                target="_blank"
            >
                {HOW_DOES_IT_WORK}
            </Link>
        </div>
    );
};

export default NewFeatureCheckout;